document.querySelectorAll('.ugc-slide').forEach(container => {
    const video = container.querySelector('.ugc-slide-video video');
    const playButton = container.querySelector('.play-btn');
    console.log("play")

    // Pausa el video al cargar
    video.pause();

    // Evento al hacer clic en el botón de reproducción
    playButton.addEventListener('click', () => {
        video.play();
        video.setAttribute('controls', 'controls'); // Muestra controles de video
        playButton.classList.add('hidden'); // Oculta el botón de reproducción
    });

    // Opcional: muestra el botón nuevamente al pausar
    video.addEventListener('pause', () => {
        playButton.classList.remove('hidden');
        video.removeAttribute('controls'); // Oculta controles al pausar
    });
});
